import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';

export interface LoyaltySettingsDto {
  earnPointsPerCurrency: number;
  redeemValuePerPoint: number;
  minRedeemPoints: number;
  isActive: boolean;
}

export interface LoyaltyEntryDto {
  loyaltyPointsEntryId: string;
  customerId: string;
  customerName: string;
  customerPhone: string;
  orderId: string | null;
  entryType: number; // 0 Earn, 1 Redeem, 2 Adjust
  points: number;
  balanceAfter: number;
  note: string | null;
  createdAt: string;
}

const SETTINGS_QK = ['loyalty-settings'] as const;
const LEDGER_QK = ['loyalty-ledger'] as const;

export function useLoyaltySettings() {
  return useQuery({
    queryKey: SETTINGS_QK,
    queryFn: async () => (await apiClient.get<LoyaltySettingsDto>('/api/loyalty/settings')).data,
  });
}

export function useUpdateLoyaltySettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (req: LoyaltySettingsDto) =>
      (await apiClient.put<LoyaltySettingsDto>('/api/loyalty/settings', req)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: SETTINGS_QK }),
  });
}

export function useLoyaltyLedger(take = 100) {
  return useQuery({
    queryKey: [...LEDGER_QK, take],
    queryFn: async () =>
      (await apiClient.get<LoyaltyEntryDto[]>('/api/loyalty/ledger', { params: { take } })).data,
  });
}
